import {
  actionResultType,
  actionType,
} from "@/views/dashboard/workspace-integration/actionType";
import importApi from "@/api/requests/import";
import SchoologyStep1 from "@/views/dashboard/workspace-integration/schoology/SchoologyStep1.vue";
import SchoologyStep2 from "@/views/dashboard/workspace-integration/schoology/SchoologyStep2.vue";
import { LMS_PROVIDERS } from "@/constants";

const platformKey = LMS_PROVIDERS.schoology.key;
const SCHOOLOGY_API_URL = "https://app.schoology.com";

export default function schoologySteps(t) {
  return [
    {
      component: SchoologyStep1,
      action: {
        label: t("common.continue"),
        actionType: actionType.next,
        type: "primary",
      },
    },
    {
      headerTitle: t("imports.connectSchoology"),
      component: SchoologyStep2,
      action: {
        label: t("imports.connectSchoolgyButton"),
        actionType: actionType.submit,
        type: "primary",
        onSubmit: async () => {
          const { data } = await importApi[platformKey].init(SCHOOLOGY_API_URL);
          window.location.href = data.url;
          return { type: actionResultType.REDIRECT };
        },
      },
    },
  ];
}
